import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["includeCheckbox", "preSelectedLabel"]

  toggleInclude() {
    const checked = this.includeCheckboxTarget.checked

    if (this.hasPreSelectedLabelTarget) {
      this.preSelectedLabelTarget.classList.toggle("hidden", !checked)
    }
  }
}
